/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { addSearchParam, FIX_PATH_PRODUCTLIST } from "./";
import type { CategoryDto, TBreadcrumbItem } from "@hsr/types";

export const buildCategoriesBreadcrumbs = (
  dataArr: CategoryDto[],
  homeLabel: string,
  allProductsLabel: string
): TBreadcrumbItem[] | undefined => {
  if (!dataArr) return;

  const breadcrumbArr: TBreadcrumbItem[] = [
    {
      title: homeLabel,
      link: "/"
    }
  ];

  // List category hierarchy
  if (dataArr.length > 0) {
    dataArr.forEach((category) => {
      breadcrumbArr.push({
        title: category.name!,
        link: category.id!
      });
    });
  }

  // No category search param is given - show "All products"
  if (dataArr.length === 0) {
    breadcrumbArr.push({
      title: allProductsLabel,
      link: "/"
    });
  }

  return breadcrumbArr;
};

export const buildCategoriesBreadcrumbUrl = (
  categoryId: string,
  lng?: string | undefined
) => {
  const params = addSearchParam(new URLSearchParams(), "category", categoryId);

  if (!lng) return `${FIX_PATH_PRODUCTLIST}?${params.toString()}`;
  return `/${lng}${FIX_PATH_PRODUCTLIST}?${params.toString()}`;
};
